export default function useSleep(time: number) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve(true);
    }, time);
  });
}
